export default __webpack_public_path__ + "7bc09df7ec9851c15f906a5d0491363f.svg";